var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{attrs:{"formTitle":"Item Nota Fiscal","cols":_vm.cols,"resourceUrl":_vm.resourceUrl,"descriptionProperty":"descr_compl","canDelete":false,"formWidth":900}})}
var staticRenderFns = []

export { render, staticRenderFns }